export default "__VITE_ASSET__BYzXNl6I__"